var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"vac-fade-spinner","appear":""}},[(_vm.show)?_c('div',{staticClass:"vac-loader-wrapper",class:{
      'vac-container-center': !_vm.infinite && !_vm.loadingDownload,
      'vac-container-top': _vm.infinite && !_vm.loadingDownload,
      'vac-container-right': _vm.loadingDownload,
    }},[_vm._t("spinner-icon",function(){return [_c('div',{class:{
          'loader-message-file': _vm.fromMessageFile,
        },attrs:{"id":"vac-circle"}})]},null,{ show: _vm.show, infinite: _vm.infinite })],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }